import { useState } from "react";
import { Box, Tooltip, Typography } from "@material-ui/core";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { columnTextField } from "utils/tables-utils";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import ReactExport from "react-export-excel";

import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@material-ui/icons";
import { IsMobile } from "utils/is-mobile";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const TabelaMonitorSeniorSeta = ({ dataTable }) => {
  const isMobile = IsMobile();

  let charLimit = 120;

  if (isMobile) {
    charLimit = 20;
  }

  const exportIconStyle = {
    width: 28,
    height: 28,
    marginLeft: 10,
  };

  const ExpandableText = ({ text, charLimit = 120 }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
      setIsExpanded(!isExpanded);
    };

    const isTextLong = text?.length > charLimit;

    return (
      <div>
        {isExpanded || !isTextLong
          ? text
          : `${text.substring(0, charLimit)}...`}
        {isTextLong && (
          <IconButtonLoader
            title="Expandir texto"
            size="small"
            onClick={toggleExpand}
            icon={isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          />
        )}
      </div>
    );
  };

  const columnModel = [
    columnTextField(
      {
        dataField: "Filial",
        text: "Filial",
        align: "init",
        headerStyle: { width: 120 },
      },
      false
    ),
    columnTextField(
      {
        dataField: "DataPedidoFormat",
        text: "Data",
        align: "init",
        headerStyle: { width: 120 },
      },
      false
    ),
    columnTextField(
      {
        dataField: "NotaFiscal",
        text: "Nota Fiscal",
        align: "init",
        headerStyle: { width: 120 },
      },
      false
    ),
    columnTextField(
      {
        dataField: "Pedido",
        text: "Pedido",
        align: "init",
        headerStyle: { width: 120 },
      },
      false
    ),
    columnTextField(
      {
        dataField: "Observacao",
        text: "LOG Erro",
        align: "init",
        headerStyle: { width: "100%" },
        formatter: (cell) => (
          <ExpandableText text={cell} charLimit={charLimit} />
        ),
        style: {
          whiteSpace: "normal",
          wordWrap: "break-word",
        },
      },
      false
    ),
  ];

  return (
    <>
      <ToolkitTable
        searched={Boolean(dataTable)}
        keyField="Pedido"
        dataTable={dataTable}
        columnModel={columnModel}
        pagination={{
          options: [25, 50, 100],
          defaultOption: 25,
          totalSize: dataTable?.length,
          showTotal: true,
        }}
        headerTitle="Erros Integração Seta x Senior"
        notFoundTitle="Sua pesquisa não encontrou pedidos correspondentes."
        CustomHeader={() => (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            className="pl-4"
            style={{ height: 60, padding: "0 24px" }}
          >
            <Box component={Typography} variant="h2" marginBottom="0!important">
              <Box component="span">Telas</Box>
            </Box>
            <Box style={{ marginLeft: 15, marginRight: 15, cursor: "pointer" }}>
              <ExcelFile
                element={
                  <Tooltip title="Exportar Tudo">
                    <IconButtonLoader
                      extraStyle={exportIconStyle}
                      icon={
                        <img
                          src="https://img.icons8.com/material-outlined/72/000000/xls-export.png"
                          alt="ícone clicável para exportar a tabela no formato Excel"
                          style={exportIconStyle}
                        />
                      }
                      size="small"
                    />
                  </Tooltip>
                }
                filename={"ErrosIntegraçãoSetaxSenior"}
              >
                <ExcelSheet
                  data={dataTable}
                  name={"ErrosIntegraçãoSetaxSenior"}
                >
                  <ExcelColumn label="Filial" value="Filial" />
                  <ExcelColumn label="DataPedidoFormat" value="Data" />
                  <ExcelColumn label="Nota Fiscal" value="NotaFiscal" />
                  <ExcelColumn label="Pedido" value="Pedido" />
                  <ExcelColumn label="LOG Erro" value="Observacao" />
                </ExcelSheet>
              </ExcelFile>
            </Box>
          </Box>
        )}
      />
    </>
  );
};

export default TabelaMonitorSeniorSeta;
